module.exports = __webpack_public_path__ + "static/media/lendings.bd7830b2.svg";